/**
 * Copy-to-clipboard button — inline button that copies text and shows feedback.
 *
 * CSS: styles/utilities.css (.copy-btn)
 */

import { action } from './action-delegation.js'

/** Render an inline copy button next to an ID or value. */
export function renderCopyBtn(text: string): string {
  return `<button class="copy-btn" ${action('copyToClip', text)} aria-label="Copy" title="Copy">\u2398</button>`
}

/** Copy text to clipboard and show visual feedback on the button. */
export function copyToClip(text: string, btn: HTMLElement): void {
  navigator.clipboard.writeText(text).then(
    () => {
      const original = btn.textContent
      btn.textContent = '\u2713'
      setTimeout(() => {
        btn.textContent = original
      }, 1000)
    },
    () => {
      // Clipboard API not available — silent fail
    },
  )
}
